import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Menu, MenuItem } from "@material-ui/core";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"

import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Grow from '@material-ui/core/Grow';
import FilterPanel from './FilterPanel';


import Typography from "@material-ui/core/Typography";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';


import LinearProgress from "@material-ui/core/LinearProgress"

import RequestSmsReceiver from "./RequestSmsReceiver";
import FloatingLabelInput from "./FloatingLabelInput";

import Select from "react-select";
import CurrentComments from "./currentComments";
import LastYearCurrentCustomersComments from "./LastYearCurrentCustomersComments";
import InsuranceDetailsCard from "./InsuranceDetailsCard";




const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    progress: {
        width: '100%',
        height: 10, // ارتفاع نوار درصد
    },
    progressContainer: {
        width: '100px', // عرض نوار درصد
    }
})
const Text = (props) => {
    return (
        <Container>
            <div className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
            </div>
        </Container>
    );
};

class LastYearCurrentCustomers extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            selectedStatus: null,
            selectedRepresentation: null,
            selectedDateCallback: null,
            selectedDayEnd: "",
            selectedDayStart: "",
            anchorEl: null, // برای مدیریت موقعیت منو
            currentRowId: null, // برای نگهداری ID ردیف جاری
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            orderBy2: [], // لیست فیلدهای مرتب‌شده
            order2: [],
            agentInfofilter2: [],
            agentInfofilter3: [],
            rowsPerPage: 10,
            page: 0,
            id: "",
            idrequest: "",

            accident_main_coverage_name: "",

            insurer: "",
            full_name: "",
            typePolicy: "",
            beginDate: "",
            endDate: "",
            sms_date: "",
            excel_name: "",
            vehicalName: "",
            plateNumber: "",
            policyholder: "",
            phone_number: "",
            representation: "",
            phone: "",
            string: "",
            address: "",
            nationalCode: "",
            message_content: "",
            resend_sms: "",
            discountFinance: "",
            discountLife: "",
            discountDriver: "",
            lastPolicyNumber: "",
            policyNumber: "",
            policyUniqueCode: "",
            engineNumber: "",
            chassisNo: "",
            vin: "",
            call_back_desc: "",
            call_back_status: "",
            sheller: "",
            sheller_end_date: "",
            call_back_date: "",
            searchText: "",
            isEmployeeFilterActive: false,
            employee_id: "",
            auth_id: "",
            is_called: "",
            last_status: "",
            no_major_damage: "",
            no_additional_damage: "",

            orderBy: "id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newAccidentMainCoverage: true,
            request_id: null, // مقدار اولیه
            cheak_box_desc: "",
            isChecked: "false",




        }

    }

    clearDeyEnd = (event) => {
        this.setState({ selectedDayEnd: "" }, () => {
            // this.filterList();
        });
    };

    setSelectedDayEnd = (event) => {
        this.setState({ selectedDayEnd: event }, () => {
            // this.filterList();
        });
    };
    setSelectedStatus = (selectedOption) => {
        this.setState({ selectedStatus: selectedOption });
    }
    setSelectedRepresentation = (selectedOption) => {
        this.setState({ selectedRepresentation: selectedOption });
    }
    setselectedDateCallback = (event) => {
        this.setState({ selectedDateCallback: event });
    };

    clearDeyStart = (event) => {
        this.setState({ selectedDayStart: "" }, () => {
            // this.filterList();
        });
    };

    setSelectedDayStart = (event) => {
        this.setState({ selectedDayStart: event }, () => {
            // this.filterList();
        });
    };
    handleChangeDesc = (event) => {
        this.setState({ call_back_desc: event.target.value });
    };

    handleCheckboxChange = (event) => {
        // تغییر وضعیت چک‌باکس
        this.setState({ isChecked: event.target.checked ? "true" : "false" });
    };
    gotoDetailRequest = (id,call_back_desc,call_back_status,call_back_date) => {

        this.setState({ call_back_desc: call_back_desc })
        this.setState({ isChecked: call_back_status })
        if (call_back_date) {
            const [year, month, day] = call_back_date.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedDateCallback: parsedDate });
        } else {
            this.setState({ selectedDateCallback: null });
        }

        if (this.state.request_id === id) {
            this.setState({ request_id: null });
        }else {
            this.setState({ request_id: id })

        }
    }

    handleClick = (event, rowId) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedRowId: rowId,
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
            selectedRowId: null,
        });
    };

    handleSelectRows = (row2) => {
        this.setState(
            {
                id: row2.id,
                accident_main_coverage_name: row2.accident_main_coverage_name,
                insurer: row2.insurer,
                full_name: row2.full_name,
                typePolicy: row2.typePolicy,
                beginDate: row2.beginDate,
                endDate: row2.endDate,
                sms_date: row2.sms_date,
                excel_name: row2.excel_name,
                vehicalName: row2.vehicalName,
                plateNumber: row2.plateNumber,
                policyholder: row2.policyholder,
                phone_number: row2.phone_number,
                representation: row2.representation,
                address: row2.address,
                phone: row2.phone,
                string: row2.string,
                nationalCode: row2.nationalCode,
                message_content: row2.message_content,
                resend_sms: row2.resend_sms,
                discountFinance: row2.discountFinance,
                discountLife: row2.discountLife,
                discountDriver: row2.discountDriver,
                lastPolicyNumber: row2.lastPolicyNumber,
                policyNumber: row2.policyNumber,
                policyUniqueCode: row2.policyUniqueCode,
                engineNumber: row2.engineNumber,
                chassisNo: row2.chassisNo,
                vin: row2.vin,
                call_back_desc: row2.call_back_desc,
                call_back_status: row2.call_back_status,
                sheller: row2.sheller,
                sheller_end_date: row2.sheller_end_date,
                call_back_date: row2.call_back_date,
                employee_id: row2.employee_id,
                auth_id: row2.auth_id,
                is_called: row2.is_called,
                last_status: row2.last_status,
                request_id: row2.request_id,
                no_major_damage: row2.no_major_damage,
                no_additional_damage: row2.no_additional_damage,
                newAccidentMainCoverage: false,
            },
            () => {}
        )
    }




    filterRows = () => {

        const { agentInfofilter, isEmployeeFilterActive, searchText } = this.state;

        return agentInfofilter
            .filter((row) => {
                if (isEmployeeFilterActive && row.employee_id !== row.auth_id) return false;

                if (!searchText.trim()) return true;

                const lowerSearch = searchText.toLowerCase();

                // چک کن ببین آیا حداقل یکی از فیلدها شامل سرچ هست
                return Object.values(row).some((value) =>
                    String(value).toLowerCase().includes(lowerSearch)
                );
            });
    };

    newAccidentMainCoverage = (event) => {
        this.setState({
            id: "",
            accident_main_coverage_name: "",
            insurer: "",
            newAccidentMainCoverage: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getSmsReceiverStatus()
                        self.getSmsReceiverRepresentation()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    datafilter = async () => {

        this.props.props.props.dispatch({ type: "WAITSHOW" });

        const { selectedDayStart, selectedDayEnd, searchText, selectedStatus , selectedRepresentation } = this.state;


        // if (selectedDayStart && selectedDayEnd ) {
        // همه دارای مقدار هستن
        const formatDate = ({ day, month, year }) => {
            const paddedMonth = month.toString().padStart(2, '0');
            const paddedDay = day.toString().padStart(2, '0');
            return `${year}/${paddedMonth}/${paddedDay}`;
        };

        const formattedStartDate = formatDate(selectedDayStart);
        const formattedEndDate = formatDate(selectedDayEnd);
        const selectedStatusId = selectedStatus;
        const representation = selectedRepresentation;

        try {
            // آماده کردن داده‌ها به صورت JSON
            const payload = {
                StartDate: formattedStartDate ,
                EndDate: formattedEndDate|| "",
                StatusId: selectedStatusId || "",
                representation: representation || "",
            };



            // ارسال درخواست با fetch - JSON
            const response = await fetch(`${constants.BASE_URL}/CurrentCustomers/showLastYear`, {
                method: "POST",
                headers: {
                    "Authorization": this.cookies.get("employee_token_str"),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            // مخفی کردن لودینگ
            this.props.props.props.dispatch({ type: "WITEHIDE" });

            if (result.result === "ok") {
                this.setState({ snackstr: result.desc, showSnack: true, snackMode: "success" })

                this.setState(
                    {
                        requestinfos: result.data,
                        agentInfofilter: result.data
                    },
                    () => {
                        // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                        this.applySorting(); // مرتب‌سازی داده‌ها
                    }
                );

            } else {
                this.setState({ snackstr: result.desc, showSnack: true, snackMode: "error" })
            }

        } catch (error) {
            console.error('Error:', error);
            this.props.props.props.dispatch({ type: "WITEHIDE" });
            this.setState({ snackstr: 'خطا در ارتباط با سرور', showSnack: true, snackMode: "error" })

        }
    };

    onBase = () => {
        this.setState({
            selectedDayEnd: "",
            selectedDayStart: "",
            selectedStatus: "",
            selectedRepresentation: "",
        });
    }


    handleCallStatusUpdate3 = (row) => {

        const nationalCode = row.nationalCode;
        const plate = row.plateNumber;
        const regex = /^([0-9\u06F0-\u06F9]{2})ایران([0-9\u06F0-\u06F9]{3})([آ-ی])([0-9\u06F0-\u06F9]{2})$/;

        const match = plate.match(regex);

        const lastTwo = match[1];   // "33"
        const threeDigits = match[2]; // "438"
        const letter = match[3];      // "ج"
        const twoDigits = match[4];     // "75"

        console.log("دو رقم اول:", twoDigits);
        console.log("سه رقم وسط:", threeDigits);
        console.log("حرف:", letter);
        console.log("دو رقم آخر:", lastTwo);

        // const url = `http://localhost:3000/thirdparty?nationalCode=${nationalCode}&start=${twoDigits}&middle=${threeDigits}&letter=${letter}&end=${lastTwo}`;
        const url = `https://user2.rahnamayefarda.ir/thirdparty?nationalCode=${nationalCode}&start=${twoDigits}&middle=${threeDigits}&letter=${letter}&end=${lastTwo}`;
        console.log("URL ساخته شده:", url);
        window.open(url, "_blank");

        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    getSmsReceiverStatus() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter2: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_sms_status")

        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }
    getSmsReceiverRepresentation() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter3: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "last_year_sms_representation")

        xhttp.open("POST", `${constants.BASE_URL}/SmsReceiver`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }



    // تابع برای اعمال مرتب‌سازی دوباره بر اساس فیلد و وضعیت مرتب‌سازی
    applySorting = () => {
        const { orderBy2, order2 } = this.state;
        const arrayTemp = [...this.state.agentInfofilter];

        // مرتب‌سازی بر اساس فیلدهای مختلف
        arrayTemp.sort((a, b) => {
            let comparisonResult = 0;

            // مقایسه داده‌ها در ترتیب اولویت
            for (let i = 0; i < orderBy2.length; i++) {
                const field = orderBy2[i];
                const orderDirection = order2[i];

                const valueA = field === 'endDate' ? new Date(a[field]) : a[field];
                const valueB = field === 'endDate' ? new Date(b[field]) : b[field];

                if (orderDirection === 'asc') {
                    comparisonResult = valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
                } else {
                    comparisonResult = valueA > valueB ? -1 : (valueA < valueB ? 1 : 0);
                }

                if (comparisonResult !== 0) break; // اگر مقایسه‌ها نتیجه‌دار شدند، دیگر مقایسه نمی‌کنیم
            }

            return comparisonResult;
        });

        // به‌روزرسانی state با داده‌های مرتب‌شده
        this.setState({ agentInfofilter: arrayTemp });
    };




    createSortHandler = (field) => {
        const { orderBy2, order2 } = this.state;

        const fieldIndex = orderBy2.indexOf(field);

        // اگر فیلد جدید است، آن را به لیست اضافه می‌کنیم
        if (fieldIndex === -1) {
            this.setState(
                {
                    orderBy2: [...orderBy2, field],
                    order2: [...order2, 'asc'], // پیش‌فرض ترتیب صعودی است
                },
                this.applySorting
            );
        } else {
            // اگر فیلد قبلاً وجود دارد، ترتیب آن را تغییر می‌دهیم
            const newOrder = [...order2];
            newOrder[fieldIndex] = newOrder[fieldIndex] === 'asc' ? 'desc' : 'asc';

            this.setState(
                {
                    order2: newOrder
                },
                this.applySorting
            );
        }
    };


    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }

    render() {
        const { anchorEl } = this.state; // موقعیت منو
        const { orderBy2, order2 } = this.state;
        const { classes } = this.props
        const {
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            searchText,
            isEmployeeFilterActive,
            newAccidentMainCoverage,
            id,
            accident_main_coverage_name,
            insurer,
            full_name,
            typePolicy,
            beginDate,
            endDate,
            vehicalName,
            selectedStatus,
            selectedRepresentation,
            selectedDayEnd,
            selectedDayStart,
            plateNumber,
            policyholder,
            phone_number,
            representation,
            nationalCode,
            message_content,
            call_back_desc,
            no_major_damage,
            no_additional_damage,
            call_back_status,
            discountFinance,
            discountLife,
            discountDriver,
            lastPolicyNumber,
            policyNumber,
            policyUniqueCode,
            engineNumber,
            is_called,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            agentInfofilter2,
            agentInfofilter3,
            rowsPerPage,
            page,
            cheak_box_desc,

        } = this.state

        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="xl">



                                <FilterPanel
                                    className={classes.root}
                                    searchText={this.state.searchText}
                                    onSearchTextChange={(val) => this.setState({ searchText: val })}
                                    selectedDayStart={this.state.selectedDayStart}
                                    onStartDateChange={(val) => this.setState({ selectedDayStart: val })}
                                    selectedDayEnd={this.state.selectedDayEnd}
                                    onEndDateChange={(val) => this.setState({ selectedDayEnd: val })}
                                    selectedStatus={this.state.selectedStatus}
                                    onStatusChange={(val) => this.setState({ selectedStatus: val })}
                                    statusOptions={agentInfofilter2.map(item => ({
                                        value: item.sms_status_id,
                                        label: item.sms_status
                                    }))}
                                    selectedRepresentation={this.state.selectedRepresentation}
                                    onRepresentationChange={(val) => this.setState({ selectedRepresentation: val })}

                                    representationOptions={agentInfofilter3.map(item => ({
                                        value: item.representation_fullname,
                                        label: item.representation_fullname
                                    }))}
                                    onSearch={this.datafilter}
                                    onBase={this.onBase}
                                    excel={'current_customers_tb'}
                                />


                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>



                                                <TableRow>
                                                    <TableCell
                                                        key={"id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "id" ? order : false}
                                                    >
                                                        {"آیدی "} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "id"}
                                                            direction={
                                                                orderBy === "id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"endDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ پایان"} <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("endDate")}
                                                            direction={orderBy2.includes("endDate") ? order2[orderBy2.indexOf("endDate")] : "asc"}
                                                            onClick={() => this.createSortHandler("endDate")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"excel_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام اکسل"} <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("excel_name")}
                                                            direction={orderBy2.includes("excel_name") ? order2[orderBy2.indexOf("excel_name")] : "asc"}
                                                            onClick={() => this.createSortHandler("excel_name")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"plateNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پلاک ماشین"} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "plateNumber"}
                                                            direction={
                                                                orderBy === "plateNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("plateNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyholder"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام/نام خانوادگی"} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "policyholder"}
                                                            direction={
                                                                orderBy === "policyholder" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyholder")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"phone_number"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موبایل"} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "phone_number"}
                                                            direction={
                                                                orderBy === "phone_number" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("phone_number")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"representation"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نمایندگی"} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "representation"}
                                                            direction={
                                                                orderBy === "representation" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("representation")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    <TableCell
                                                        key={"call_back_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تماس مجدد"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("call_back_status")}
                                                            direction={orderBy2.includes("call_back_status") ? order2[orderBy2.indexOf("call_back_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("call_back_status")}
                                                        />
                                                    </TableCell>

                                                    <TableCell
                                                        key={"sheller"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شلر"} <br />
                                                        <TableSortLabel
                                                            active={orderBy === "sheller"}
                                                            direction={
                                                                orderBy === "sheller" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("sheller")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                    {/*<TableCell*/}
                                                    {/*    key={"is_called"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"تعیین وضعیت"}*/}
                                                    {/*    <br/>*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "is_called"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "is_called" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("is_called")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"آخرین وضعیت"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("last_status")}
                                                            direction={orderBy2.includes("last_status") ? order2[orderBy2.indexOf("last_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("last_status")}
                                                        />
                                                    </TableCell>

                                                    <TableCell
                                                        key={"price"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"قیمت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "price"}
                                                            direction={
                                                                orderBy === "price" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("price")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>



                                                {this.filterRows()
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        if (isEmployeeFilterActive && row.employee_id !== row.auth_id) {
                                                            return null;
                                                        }
                                                        const color = row.percentage < 50 ? 'red' : row.percentage < 80 ? 'yellow' : 'green';
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.gotoDetailRequest(row.id,row.call_back_desc,row.call_back_status,row.call_back_date)
                                                                }}
                                                                style={{
                                                                    backgroundColor:
                                                                        row.last_status === "در حال بررسی"
                                                                            ? "#F5F5DC" // زرد کرمی
                                                                            : row.last_status === "تمدید شد"
                                                                                ? "#EAF3FB" // سبز ملایم
                                                                                : row.last_status === "بررسی نشده"
                                                                                    ? "#FDEDEC" // قرمز ملایم
                                                                                    : row.last_status === "نهایی شد"
                                                                                        ? "#E6F4EA" // سبز نعناعی ملایم
                                                                                        : "transparent",

                                                                    transition: "background-color 0.3s ease",
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"endDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["endDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"excel_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["excel_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"plateNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["plateNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyholder"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyholder"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"phone_number"}
                                                                    align={"center"}
                                                                >
                                                                    {row["phone_number"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"representation"}
                                                                    align={"center"}
                                                                >
                                                                    {row["representation"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"call_back_desc"}
                                                                    align={"center"}
                                                                    style={{
                                                                        backgroundColor: row["call_back_status"] === "true" ? "green" : "transparent", // سبز در حالت true
                                                                        color: row["call_back_status"] === "true" ? "white" : "inherit", // متن سفید فقط در حالت true
                                                                    }}
                                                                >
                                                                    {/*{row["call_back_status"] === "true" ? "بله" : "خیر"}*/}
                                                                    <br />
                                                                    {row["call_back_date"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"sheller"}
                                                                    align={"center"}
                                                                >
                                                                    {row["sheller"]}
                                                                </TableCell>


                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {row["last_status"]}
                                                                    {<h5> ({row["full_name"]}) </h5>}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"price"}
                                                                    align={"center"}
                                                                >


                                                                    <div>
                                                                        {/* دکمه برای فعال/غیرفعال کردن شرط */}
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"

                                                                            onClick={(event) => {
                                                                                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک
                                                                                this.handleCallStatusUpdate3(row);
                                                                            }}

                                                                        >

                                                                            قیمت$
                                                                        </Button>
                                                                    </div>

                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={this.filterRows().length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>

                            <Container component="main" maxWidth="lg">

                                <Container maxWidth="lg">
                                    {agentInfofilter
                                        .map((row) => {
                                            const color = this.state['request_id'];
                                            if (color === row.id) {
                                                return (
                                                    <TableContainer component={Paper}>
                                                        <InsuranceDetailsCard key={row.id} data={row} />


                                                    </TableContainer>




                                                )
                                            }

                                        })}




                                </Container>




                                <Container maxWidth="lg">

                                    <LastYearCurrentCustomersComments request_id={this.state['request_id']} />
                                </Container>





                            </Container>
                        </Grid>
                    </Grid>


                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>


            )
        }
    }
}


export default withStyles(styles)(LastYearCurrentCustomers)
